import { useEffect, useState, useCallback } from "react";
import { useIngresoINMOB } from "../../Services/Inmobiliaria/Ingresos";

export const useIngresoTodosINMOB = () => {
  const { 
    getingresos, 
    getCategoriaingresos,  
    getContactoInmobiliaria, 
    getfiltromeses,
    getfiltromesesyaño } = useIngresoINMOB();
  const [IngresosInmob, setIngresosInmob] = useState([]);
  const [errorIngresosInmob, setErrorIngresosInmob] = useState(null);
  const [loadingIngresosInmob, setLoadingIngresosInmob] = useState(true);

  /* categoria */
  const [IngresosCategoriaInmob, setIngresosCategoriaInmob] = useState([]);
  const [errorIngresosCategoriaInmob, setErrorIngresosCategoriaInmob] = useState(null);
  const [loadingIngresosCategoriaInmob, setLoadingIngresosCategoriaInmob] = useState(true);

  /* contacto */
  const [contactos, setContactos] = useState([]);
  const [loadingContactos, setLoadingContactos] = useState(true);
  const [errorContactos, setErrorContactos] = useState(null);

  const [meses, setMeses] = useState([]);
const [ingresos, setIngresos] = useState(null);
const [mesSeleccionado, setMesSeleccionado] = useState("");
const [anioSeleccionado, setAnioSeleccionado] = useState("");
const [loadingMeses, setLoadingMeses] = useState(true);


  const fetchIngresoINMOB = useCallback(async () => {
  setLoadingIngresosInmob(true);
  try {
    const data = await getingresos();
    setIngresosInmob(data);
  } catch (error) {
    setErrorIngresosInmob(error?.message || "Error al obtener ingresos");
  } finally {
    setLoadingIngresosInmob(false);
  }
}, []); 

 const fetchIngresoCategoriaINMOB = useCallback(async () => {
  setLoadingIngresosCategoriaInmob(true);
  try {
    const data = await getCategoriaingresos();
    setIngresosCategoriaInmob(data);
  } catch (error) {
    setErrorIngresosCategoriaInmob(error?.message || "Error al obtener ingresos");
  } finally {
    setLoadingIngresosCategoriaInmob(false);
  }
}, []); 

/* contacto */
 const fetchContactos = useCallback(async () => {
    setLoadingContactos(true);
    try {
      const data = await getContactoInmobiliaria();
      setContactos(data?.data ?? data);
    } catch (error) {
      setErrorContactos(error?.message);
    } finally {
      setLoadingContactos(false);
    }
  }, [getContactoInmobiliaria]);

  useEffect(() => {
    fetchIngresoINMOB();
     fetchIngresoCategoriaINMOB();
    fetchContactos();
  }, []);

  const fetchMeses = useCallback(async () => {
  setLoadingMeses(true);
  try {
    const data = await getfiltromeses();
    setMeses(data);
  } catch (error) {
    console.error(error);
  } finally {
    setLoadingMeses(false);
  }
}, [getfiltromeses]);

useEffect(() => {
  fetchMeses();
}, [fetchMeses]);

  return {
   IngresosInmob,
    errorIngresosInmob,
    loadingIngresosInmob,
    IngresosCategoriaInmob,
    errorIngresosCategoriaInmob,
    loadingIngresosCategoriaInmob,
    refetchIngresoINMOB: fetchIngresoINMOB,
    refetchIngresoCategoriaINMOB: fetchIngresoCategoriaINMOB,
    contactos,
    loadingContactos,
    errorContactos,
    refetchContactos: fetchContactos,
     meses,
  loadingMeses,
  mesSeleccionado,
  setMesSeleccionado,
  anioSeleccionado,
  setAnioSeleccionado,
  ingresos,
  setIngresos,
  getfiltromesesyaño
  };
}
